<div class="session-timeout-dialog">
  <h3>{{ "session_timeout.dialog.title" | translate }}</h3>
  <h1 class="countdown">
    {{ timeRemainingFormatted$ | async }}
  </h1>
</div>
